import { render, staticRenderFns } from "./modalProgressGris.vue?vue&type=template&id=295c2009&"
import script from "./modalProgressGris.vue?vue&type=script&lang=js&"
export * from "./modalProgressGris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports